import { render, staticRenderFns } from "./UmsTokens.vue?vue&type=template&id=f713042a&"
import script from "./UmsTokens.vue?vue&type=script&lang=js&"
export * from "./UmsTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports